import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { animated } from "react-spring";
import { InputBase, InputBaseProps, inputBaseClasses } from "@mui/material";
import React from "react";
import Button from "@/components/Button";

interface CustomInputWrapperProps {
	marginBottom?: number;
	width?: string;
}

export const CustomInputWrapper = styled.div<CustomInputWrapperProps>`
	margin-bottom: ${({ marginBottom }) => marginBottom}px;
	position: relative;
`;

export const CustomInputTitle = styled.p`
	font-size: 14px;
	line-height: 24px;
	color: #000000;
`;

export interface CustomInputBaseProps extends InputBaseProps {
	height?: number;
	sidePadding?: number;
	error?: boolean;
}

export const CustomInputBase = styled(
	({ sidePadding, height, error, ...args }: CustomInputBaseProps) => (
		<InputBase {...args} />
	),
)`
	&.${inputBaseClasses.root} {
		padding: 0;
	}

	& .MuiInputBase-input {
		padding: 0;
		font-size: 14px;
		border: 1px solid #e0e0e0;
		border-radius: 4px;

		&:hover,
		&:focus {
			border: 1px solid #000;
		}

		&::placeholder {
			font-size: 14px;
			color: #676767;
			opacity: 0.8;
		}

		${({ multiline }) =>
			multiline &&
			css`
				padding-top: 16px;
				padding-bottom: 16px;
			`}
		${({ sidePadding }) =>
			sidePadding &&
			css`
				padding-left: ${sidePadding}px;
				padding-right: ${sidePadding}px;
			`}
		${({ error }) =>
			error &&
			css`
				&,
				&:hover,
				&:focus {
					border: 1px solid #ff0000;
				}
			`}
		height: ${({ height }) => height || 40}px;
	}
`;

export const InputButtonWrapper = styled(animated.div)`
	display: flex;
	width: 100%;
	justify-content: flex-end;
	margin-top: 10px;
	align-items: center;
`;

export const InputButton = styled(Button)`
	width: 66px;
	height: 34px;
	box-shadow: none;
	border: 1px solid #0071e3;

	&:hover {
		box-shadow: none;
	}
`;

export const InputButtonCancel = styled(InputButton)`
	margin-right: 4px;
	color: #747474;
	border: 1px solid #ccc;
`;

export const InputErrorText = styled.p`
	font-size: 12px;
	color: #ff0000;
	position: absolute;
	left: 0;
	top: 100%;
`;
